import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import clarifyPriceIcon from 'shared/assets/images/price.svg';
import { FormattedMessage } from 'react-intl';

import s from './ClarifyPriceLink.css';

class ClarifyPriceLink extends React.Component {
  static propTypes = {
    link: PropTypes.string.isRequired,
    text: PropTypes.string,
  };

  static defaultProps = {
    text: 'Уточнить',
  };

  render() {
    return (
      <a href={this.props.link} className={s.clarifyPriceLink} target="_blank">
        <img width={20} src={clarifyPriceIcon} className={s.clarifyPriceIcon} alt="" />
        <FormattedMessage id={this.props.text} />
      </a>
    );
  }
}

export default withStyles(s)(ClarifyPriceLink);



// WEBPACK FOOTER //
// ./src/shared/components/ClarifyPriceLink/ClarifyPriceLink.js